module.exports = {"TXTCLI_Confirm_Details":{"id":"TXTCLI_Confirm_Details","defaultMessage":"情報を確認","track":"Confirm Details"}}